"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createComponentBinder = createComponentBinder;
exports.createComponentInstantiator = createComponentInstantiator;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeGuards = require("@insided/shared/utils/typeGuards");

var _index = require("./index");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Creates a function that instantiates components based on the dataset key.
 *
 * @param selector - The selector to use for the components.
 * @param initializer - The function that instantiates the component.
 * @param datasetKey - The key to use for the dataset.
 * @returns A function that instantiates components based on the dataset key.
 *
 *  * @example
 * In control app:
 * ```ts
 * const instantiateControlComponents = createComponentInstantiator('[data-control]', initialiseControlComponent, 'control')
 * ```
 *
 * This matches all components what would be initialised by the control app.
 */
function createComponentInstantiator(selector, initializer, datasetKey) {
  return function instantiateComponents(wrapperComponent) {
    var components = wrapperComponent.querySelectorAll("".concat(selector, ", user-mention, content-quote, content-spoiler, oembed"));

    var _iterator = _createForOfIteratorHelper(components),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _el = _step.value;
        if (!(0, _typeGuards.isHtmlElement)(_el)) continue;

        try {
          var _el$dataset$datasetKe;

          initializer((_el$dataset$datasetKe = _el.dataset[datasetKey]) !== null && _el$dataset$datasetKe !== void 0 ? _el$dataset$datasetKe : _el.tagName.toLowerCase() + '/index', _el, _el.dataset.props ? JSON.parse(_el.dataset.props) : _objectSpread(_objectSpread({}, _el.dataset), {}, {
            content: _el.innerHTML
          }));
        } catch (error) {
          (0, _index.logError)(error);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
}
/**
 * Creates a function that binds components to the wrapper component.
 *
 * @param instantiateComponents - The function that instantiates the components.
 * @returns A function that binds components to the wrapper component.
 *
 *  * @example
 * In control app:
 * ```ts
 * const bindControlComponents = createComponentBinder(instantiateControlComponents)
 * ```
 */


function createComponentBinder(instantiateComponents) {
  return function bindComponents(wrapperComponent) {
    (0, _index.prepareSpoilersAndQuotes)(wrapperComponent);
    wrapperComponent.querySelectorAll('oembed').forEach(function (content) {
      var _content$getAttribute;

      if (!(0, _typeGuards.isHtmlElement)(content)) return;
      content.dataset.url = (_content$getAttribute = content.getAttribute('url')) !== null && _content$getAttribute !== void 0 ? _content$getAttribute : '';
    });
    instantiateComponents(wrapperComponent);
    (0, _index.highlightCodeBlocks)(wrapperComponent);
  };
}